// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loader, Toastr, Button, Label, Input } from "@revvsales/components";

// Components Imports
import { ReactSelect } from "../../commonComponents";
import spreadsheetIcon from "../../assets/spreadsheet-icon.png";

// ACTION IMPORTS
import { GoogleSheetActions } from "../../actions";

// Services Imports && methods
import {
  fetchGoogleSheetById,
  authGoogleSheetService,
} from "../../actions/GoogleSheetActions/googleSheetServices";
import { googleSheetViewControl } from "../../actions/GoogleSheetActions/methods";

// Internal Imports
import { GlobalUtils } from "../../utils";
import { GOOGLE_SHEET_VIEW_CONTROL } from "../../constants";

// Destructuring
const {
  fetchGoogleWorkSheet,
  setWorkSheet,
  clearSelectedGSheetData,
  reUpdateWorkSheetOptions,
  makeEmptyRange,
  updatefirstRowAsHeaderKey,
} = GoogleSheetActions;
const {
  readDataFromLocalStorage,
  handleApiErrMsg,
  writeDataToLocalStorage,
} = GlobalUtils;

class SelectedSheetComponent extends Component {
  state = {
    loader: false,
    loaderMsg: "",
    worksheetOptions: [],
    errorMsg: "",
  };

  componentDidMount() {
    const { sheetData } = this.props;
    this._onInit(sheetData.id);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.sheetData.id !== this.props.sheetData.id ||
      this.props.reUpdateWorkBooksOption
    ) {
      this._onInit(this.props.sheetData.id);
      if (this.props.reUpdateWorkBooksOption) {
        this.props.reUpdateWorkSheetOptions(false);
      }

      if (!this.props.currentGSheetTab.autoTrim) {
        this._setautoTrimMessage("");
      }
    }
    if (this.props.currentGSheetTab.autoTrim) {
      this._setautoTrimMessage(GOOGLE_SHEET_VIEW_CONTROL.WARNING_MESSAGE);
    }

    if (this.props.currentGSheetTab.id !== prevProps.currentGSheetTab.id) {
      this._setautoTrimMessageInFalseState("");
    }
  }

  _setautoTrimMessageInFalseState = message => {
    if (this.state.errorMsg) {
      this.setState({
        errorMsg: message,
      });
    }
  };

  _setautoTrimMessage = message => {
    if (this.state.errorMsg === "") {
      this.setState({
        errorMsg: message,
      });
    }
  };

  _onInit = sheetId => {
    if (sheetId) {
      this.setState({
        loader: true,
        loaderMsg: "Loading your sheets!",
      });
      fetchGoogleSheetById(sheetId)
        .then(res => {
          if (res && res.Workbooks && res.Workbooks.length > 0) {
            this.setState({
              loader: false,
              loaderMsg: "",
              worksheetOptions: res.Workbooks,
            });
            if (!this.props.selectedWorkSheet) {
              this.props.upatedGoogleSheetTable(res.Workbooks[0]);
            }
          } else {
            this.setState({
              loader: false,
              loaderMsg: "",
            });
          }
        })
        .catch(() => {
          this.setState({
            loader: false,
            loaderMsg: "",
          });
          Toastr.showToastr({
            type: "failure",
            message: "Something went wrong. Please try again!",
            timeout: 3000,
          });
        });
    }
  };

  _onCheckChange = value => {
    this.props.updatefirstRowAsHeaderKey(value);
  };

  _fetchGoogleSheet = () => {
    const { currentGSheetTab, sheetData, selectedWorkSheet } = this.props;
    if (
      currentGSheetTab.connected &&
      sheetData.id === currentGSheetTab.sheet.id &&
      selectedWorkSheet === currentGSheetTab.workSheet
    ) {
      if (this.props.selectedRangeValue === "") {
        this._sheetDataFetching();
      } else if (this._checkValidation()) {
        this._sheetDataFetching();
      }
    } else {
      this._sheetDataFetching();
    }
  };

  _sheetDataFetching = () => {
    // this.props.upatedSelectedRangeValueStatus();
    this.setState({
      loader: true,
      loaderMsg: "Your data is getting synced!",
    });
    let refresh = "";
    if (
      this.props.selectedRangeValue === "" &&
      this.props.currentGSheetTab.rangeValue !== ""
    ) {
      refresh = "&refresh=true";
    }
    if (this.props.selectedRangeValue === "") {
      this.props.makeEmptyRange();
    }
    this.props
      .fetchGoogleWorkSheet(
        this.props.sheetData,
        this.props.selectedWorkSheet,
        this.props.googleSheetSectionId,
        this.props.currentGSheetTab.firstRowAsHeader,
        refresh,
        this.props.selectedRangeValue,
      )
      .then(() => {
        this.setState({ loader: false, loaderMsg: "", errorMsg: "" });
        this.props.upatedSelectedRangeValueStatus();
      })
      .catch(err => {
        const message = handleApiErrMsg(err);
        this.setState({ loader: false, loaderMsg: "", errorMsg: message });
        if (message === "UnAuthenticated with Google") {
          this._authGoogleSheet(this.props.currentGSheetTab);
        }
        console.error(`SelectedSheetComponent => _fetchGoogleSheet => ${err}`);
      });
  };

  _authGoogleSheet = section => {
    // this refers ==> when google sheet auth success then move to particular tab
    const clickedTabItem = {
      name: section.label,
      alias: section.label,
      type: section.type,
      id: section.id,
    };
    authGoogleSheetService()
      .then(res => {
        writeDataToLocalStorage("lastDocPath", window.location.pathname);
        writeDataToLocalStorage("clickedTabItem", clickedTabItem);
        window.location.replace(res.AuthCodeURL);
      })
      .catch(error => {
        console.error(
          `authGoogleSheetService => authEmailVerificationService => ${error}`,
        );
      });
  };

  _checkValidation = () => {
    const d = this.props.selectedRangeValue;
    let finalStatus = false;

    /* later we need to improve the logic */

    // const regex = /([A-Z]+)(\d+):([A-Z]+)(\d+)/;
    // const regex = /([A-Z]+)([1-9][0-9]{0,10}+):([A-Z]+)([1-9][0-9]{0,10}+)/;
    // const regex = /([A-Z]+)([1-9][0-9]{0,}):([A-Z]+)([1-9][0-9]{0,})/;
    // finalStatus = regex.test(d);

    if (d.includes(":")) {
      const spilitedValue = d.split(/[:]/);
      if (spilitedValue.length === 2) {
        const firstBlock = spilitedValue[0].trim();
        const secBlock = spilitedValue[1].trim();
        const firstCharOfFirstBlock = firstBlock.charCodeAt(0);
        const secondCharOfSecondBlock = secBlock.charCodeAt(0);
        const firstCharStatus =
          (firstCharOfFirstBlock >= 65 && firstCharOfFirstBlock < 91) ||
          (firstCharOfFirstBlock >= 97 && firstCharOfFirstBlock < 123);
        const SecondCharStatus =
          (secondCharOfSecondBlock >= 65 && secondCharOfSecondBlock < 91) ||
          (secondCharOfSecondBlock >= 97 && secondCharOfSecondBlock < 123);
        if (
          firstCharStatus &&
          SecondCharStatus &&
          firstCharOfFirstBlock <= secondCharOfSecondBlock
        ) {
          const firstSec = firstBlock.replace(firstBlock.charAt(0), "");
          const secondSec = secBlock.replace(secBlock.charAt(0), "");
          if (
            firstSec &&
            secondSec &&
            (parseInt(firstSec.charAt(0), 10) !== 0 ||
              parseInt(secondSec.charAt(0) !== 0, 10)) &&
            // eslint-disable-next-line no-restricted-globals
            (!isNaN(firstSec) && !isNaN(secondSec)) &&
            parseInt(firstSec, 10) <= parseInt(secondSec, 10)
          ) {
            finalStatus = true;
          }
        }
      }
    }
    console.debug("finalStatus", finalStatus, d);
    if (d) {
      if (!finalStatus) {
        this.setState({
          errorMsg: "invalid range",
        });
      } else {
        this.setState({
          errorMsg: "",
        });
      }
    } else {
      this.setState({
        errorMsg: "",
      });
    }
    return finalStatus;
  };

  _showChangeIcon = CURRENT_USER => {
    let component = null;
    if (
      googleSheetViewControl(CURRENT_USER, this.props.docOwnerID) ===
      GOOGLE_SHEET_VIEW_CONTROL.DOC_OWNER
    ) {
      component = (
        <span
          className="googlesheet-selected-sheet-change-icon"
          onKeyPress={() => null}
          role="button"
          tabIndex="0"
          onClick={this.props.changeSheetData}>
          <FontAwesomeIcon
            icon={["far", "edit"]}
            className="breadcrumb-bredcrumb-icon"
          />
          change
        </span>
      );
    }
    return component;
  };

  _changeWorkSheetAllowed = CURRENT_USER => {
    let status = true;
    if (
      googleSheetViewControl(CURRENT_USER, this.props.docOwnerID) ===
      GOOGLE_SHEET_VIEW_CONTROL.DOC_OWNER
    ) {
      status = false;
    }
    return status;
  };

  _getSynchButtonAndCheckbox = CURRENT_USER => {
    let component = null;
    if (
      googleSheetViewControl(CURRENT_USER, this.props.docOwnerID) ===
      GOOGLE_SHEET_VIEW_CONTROL.DOC_OWNER
    ) {
      component = (
        <Fragment>
          <div className="googlesheet-selected-checkbox">
            <Input
              type="checkbox"
              checked={this.props.currentGSheetTab.firstRowAsHeader}
              onChange={e => this._onCheckChange(e.target.checked)}
              data-test="selectedsheetcomponent-checkbox"
            />
            <span className="googlesheet-selected-checkbox-label">
              Use first row as the header
            </span>
          </div>
          <div className="googlesheet-selected-checkbox">
            <Button
              data-test="selectedsheetcomponent-syncselectedsheet"
              onClick={() => this._fetchGoogleSheet()}
              disabled={!this.props.selectedWorkSheet}>
              Sync selected sheet
            </Button>
          </div>
        </Fragment>
      );
    }
    return component;
  };

  _setRange = e => {
    this.setState({
      errorMsg: "",
    });
    this.props.setRangeValue(e);
  };

  render() {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const { loader, loaderMsg, worksheetOptions } = this.state;
    const {
      sheetData,
      selectedWorkSheet,
      selectedRangeValue,
      currentGSheetTab,
      upatedGoogleSheetTable,
    } = this.props;
    if (loader) {
      return <Loader label={loaderMsg} fullScreen />;
    }
    return (
      <Fragment>
        <div className="googlesheet-selected-container">
          <Label className="googlesheet-selected-title">Selected sheet</Label>
          <div className="googlesheet-selected-sheet-name">
            <img src={spreadsheetIcon} alt="Empty Screen" />{" "}
            {sheetData && sheetData.name}
            {this._showChangeIcon(CURRENT_USER)}
          </div>
          <Label className="googlesheet-selected-title">Worksheet</Label>
          <div>
            <ReactSelect
              data-test="selectedsheetcomponent-selectedworksheet"
              options={worksheetOptions}
              value={selectedWorkSheet}
              onChange={value => upatedGoogleSheetTable(value.value)}
              isDisabled={this._changeWorkSheetAllowed(CURRENT_USER)}
            />
          </div>
          {currentGSheetTab &&
            currentGSheetTab.connected &&
            sheetData.id === currentGSheetTab.sheet.id &&
            selectedWorkSheet === currentGSheetTab.workSheet && (
              <div>
                <Label className="googlesheet-selected-title">
                  Select Range{" "}
                  {currentGSheetTab.autoTrim && (
                    <span className="googlesheet-star-mandatory-icon">*</span>
                  )}
                </Label>
                <Input
                  className={`form-control" ${
                    currentGSheetTab.autoTrim
                      ? "googlesheet-star-mandatory-field"
                      : ""
                  }`}
                  data-test="selectedsheetcomponent-range"
                  type="text"
                  placeholder="Example A1:E5"
                  value={selectedRangeValue}
                  onChange={this._setRange}
                  disabled={this._changeWorkSheetAllowed(CURRENT_USER)}
                />
                {this.state.errorMsg && (
                  <div className="row" data-test="errormessages-wrapper-row">
                    <div
                      className="col-md-10 sync-bar"
                      data-test="errormessages-section">
                      <div
                        className="requiredwitherr-icon"
                        data-test="errormessages-requiredwitherr-icon">
                        <FontAwesomeIcon
                          icon={["far", "exclamation-triangle"]}
                        />
                      </div>
                      <span
                        className="requiredwitherr-input"
                        data-test="errormessages-requiredwitherr-input">
                        {this.state.errorMsg}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            )}

          {this._getSynchButtonAndCheckbox(CURRENT_USER)}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { googleSheetId } = state.QuotationStore;
  const {
    gSheetRevvTables,
    currentGSheetTab,
    reUpdateWorkBooksOption,
  } = state.GoogleSheetStore;
  const currentGSheet = gSheetRevvTables[googleSheetId];
  const sheetConnected = !!currentGSheet;
  const { firstRowAsHeader } = currentGSheetTab;

  const {
    document: { created_by: { id: docOwnerID } } = {},
  } = state.DocumentStore;

  return {
    googleSheetSectionId: googleSheetId,
    currentGSheet,
    sheetConnected,
    currentGSheetTab,
    docOwnerID,
    reUpdateWorkBooksOption,
    firstRowAsHeader,
  };
};

const mapDispatchToProps = {
  fetchGoogleWorkSheet,
  makeEmptyRange,
  setWorkSheet,
  clearSelectedGSheetData,
  reUpdateWorkSheetOptions,
  updatefirstRowAsHeaderKey,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectedSheetComponent);



// WEBPACK FOOTER //
// ./src/components/GoogleCatalog/SelectedSheetComponent.js